module.exports = __webpack_public_path__ + "static/media/img_landing14.a1b4cbba.png";